<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="page.isNew" id="btnSave" type="submit" elevation="0" color="primary" dark
                            :loading="dataset.loading" @click="add">Salvar</v-btn>
                        <v-btn v-else id="btnSave" type="submit" elevation="0" color="primary" dark :loading="dataset.loading"
                            @click="update">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" outlined color="primary"
                            @click="goBack">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="form-card">
                    <v-card-text>
                        <v-form ref="form" v-model="valid">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="dataset.data.name" label="Nome da recorrência" :rules="[$rules.required]"
                                        outlined dense hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select v-model="dataset.data.status" :items="statusTypes" item-value="id" item-text="name"
                                        label="Status" outlined dense hide-details="auto"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="dataset.data.start_date" label="Data inicial" type="date"
                                        outlined dense hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="dataset.data.end_date" label="Data final" type="date"
                                        outlined dense hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-select v-model="dataset.data.config.type" :items="typeOptions" label="Tipo de recorrência"
                                        outlined dense hide-details="auto"></v-select>
                                </v-col>
                                <v-col cols="12" md="6" v-if="dataset.data.config.type === 'weekly'">
                                    <v-combobox v-model="dataset.data.config.weekdays" :items="weekdaysOptions" label="Dias da semana"
                                        multiple outlined dense hide-details="auto"></v-combobox>
                                </v-col>
                                <v-col cols="12" md="6" v-if="dataset.data.config.type === 'monthly'">
                                    <v-combobox v-model="dataset.data.config.monthDays" :items="monthDaysOptions" label="Dias do mês"
                                        multiple outlined dense hide-details="auto"></v-combobox>
                                </v-col>
                                <v-col cols="12" md="6" v-if="dataset.data.config.type === 'fixedDates'">
                                    <v-combobox v-model="dataset.data.config.fixedDates" label="Datas fixas" multiple outlined dense hide-details="auto" type="date"></v-combobox>
                                </v-col>
                                <v-col cols="12" md="6" v-if="['daily', 'weekly', 'monthly'].includes(dataset.data.config.type)">
                                    <v-text-field v-model.number="dataset.data.config.interval" :label="intervalLabel" type="number" min="1"
                                        :rules="[v => Number(v) >= 1 || 'Mínimo 1']" outlined dense hide-details="auto"
                                        hint="1 = sempre; 2 = um sim, um não; e assim por diante" persistent-hint></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
export default {
    name: "TripRecurrenceDetails",
    data: () => ({
        valid: true,
        page: {
            title: '',
            isNew: false,
        },
        dataset: {
            loading: false,
            data: {
                config: {
                    type: '',
                    weekdays: [],
                    monthDays: [],
                    fixedDates: [],
                    interval: 1,
                }
            }
        },
        statusTypes: [
            { id: 1, name: "Ativo" },
            { id: 2, name: "Pausado" },
            { id: 3, name: "Cancelado" },
        ],
        typeOptions: [
            { value: 'daily', text: 'Diário' },
            { value: 'weekly', text: 'Semanal' },
            { value: 'monthly', text: 'Mensal' },
            { value: 'fixedDates', text: 'Datas Fixas' },
        ],
        weekdaysOptions: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
        monthDaysOptions: Array.from({ length: 31 }, (_, i) => i + 1),
    }),
    computed: {
        intervalLabel() {
            const unit = { daily: 'dias', weekly: 'semanas', monthly: 'meses' }[this.dataset.data.config.type] || '';
            return `Repetir a cada (${unit})`;
        },
        breadcrumbItems() {
            const items = [
                { text: 'Home', disabled: false, to: '/home', exact: true },
                { text: 'Recorrências', disabled: false, to: '/recorrencias', exact: true },
            ];
            items.push({
                text: !this.page.isNew ? 'Editar' : 'Nova',
                disabled: true,
                exact: true,
            });
            return items;
        },
    },
    created() {
        this.setPage();
        this.load();
    },
    methods: {
        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Nova recorrência" : "Detalhes da recorrência";
        },
        async load() {
            if (this.page.isNew) return;
            this.dataset.loading = true;
            try {
                const response = await axios.get(`/api/v2/trip-recurrences/${this.$route.params.id}`);
                const item = response.data.content;
                const config = (typeof item.config === "string" ? JSON.parse(item.config || '{}') : item.config) || {};
                // A API devolve datas em ISO; o campo type="date" precisa de AAAA-MM-DD
                const toDate = value => value ? String(value).slice(0, 10) : null;

                this.dataset.data = {
                    ...item,
                    start_date: toDate(config.startDate || item.start_date),
                    end_date: toDate(config.endDate || item.end_date),
                    config: {
                        weekdays: [],
                        monthDays: [],
                        fixedDates: [],
                        ...config,
                        interval: Math.max(Number(config.interval) || 1, 1)
                    }
                };
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || 'Erro ao carregar detalhes da recorrência.', { position: 'top-right', timeout: 5000 });
                this.goBack();
            } finally {
                this.dataset.loading = false;
            }
        },
        async add() {
            if (!this.$refs.form.validate()) return;
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar a recorrência?',
                title: 'Recorrência',
                actions: { false: 'Cancelar', true: 'Salvar' }
            })
            if (!proceedAction) return;
            this.dataset.loading = true;
            const payload = this.buildPayload();
            try {
                await axios.post(`/api/v2/trip-recurrences`, payload, { config: { headers: { "Content-Type": "application/json" } } });
                this.$dialog.notify.info("Recorrência salva com sucesso", { position: "top-right", timeout: 2000 });
                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.dataset.loading = false;
            }
        },
        async update() {
            if (!this.$refs.form.validate()) return;
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar a recorrência?',
                title: 'Recorrência',
                actions: { false: 'Cancelar', true: 'Atualizar' }
            })
            if (!proceedAction) return;
            this.dataset.loading = true;
            const payload = this.buildPayload();
            try {
                await axios.put(`/api/v2/trip-recurrences/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });
                this.$dialog.notify.info("Recorrência atualizada com sucesso", { position: "top-right", timeout: 2000 });
                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.dataset.loading = false;
            }
        },
        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                status: this.dataset.data.status,
                start_date: this.dataset.data.start_date,
                end_date: this.dataset.data.end_date,
                // O período da config tem prioridade no cálculo das datas: mantém os dois iguais
                config: {
                    ...this.dataset.data.config,
                    startDate: this.dataset.data.start_date,
                    endDate: this.dataset.data.end_date,
                    interval: Math.max(Number(this.dataset.data.config.interval) || 1, 1)
                }
            }
            return data;
        },
        goBack() {
            this.$router.push('/recorrencias');
        },
    },
};
</script>
